/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsDiagonal2 = createReactComponent("outline", "arrows-diagonal-2", "IconArrowsDiagonal2", [["path", { "d": "M16 20l4 0l0 -4", "key": "svg-0" }], ["path", { "d": "M14 14l6 6", "key": "svg-1" }], ["path", { "d": "M8 4l-4 0l0 4", "key": "svg-2" }], ["path", { "d": "M4 4l6 6", "key": "svg-3" }]]);

export { IconArrowsDiagonal2 as default };
//# sourceMappingURL=IconArrowsDiagonal2.mjs.map
